import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
const pageStyle = {
    minHeight: "100vh",
    width: "100%",
    boxSizing: "border-box",
    padding: "8px 8px 10px",
    background: "radial-gradient(circle at top, rgba(0,255,255,0.08) 0%, rgba(0,255,255,0.02) 20%, transparent 40%), linear-gradient(180deg, #03060c 0%, #06101b 48%, #02050a 100%)",
    color: "#ecfaff",
    overflowX: "hidden",
};
const shellStyle = {
    maxWidth: "1600px",
    margin: "0 auto",
};
const panelStyle = {
    borderRadius: "18px",
    padding: "9px 12px",
    background: "rgba(7, 13, 23, 0.78)",
    border: "1px solid rgba(0,255,255,0.12)",
    boxShadow: "0 0 12px rgba(0,255,255,0.04), inset 0 0 10px rgba(255,255,255,0.02)",
    backdropFilter: "blur(8px)",
};
const cardBase = {
    appearance: "none",
    width: "100%",
    minHeight: "90px",
    borderRadius: "18px",
    padding: "11px 12px",
    textAlign: "left",
    cursor: "pointer",
    transition: "transform 0.14s ease, box-shadow 0.14s ease, border-color 0.14s ease, background 0.14s ease",
    background: "linear-gradient(180deg, rgba(10,16,28,0.96) 0%, rgba(5,10,18,0.98) 100%)",
    color: "#ecfaff",
    border: "1px solid rgba(90, 220, 255, 0.18)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.02)",
};
export default function Education() {
    const navigate = useNavigate();
    const featuredItems = [
        {
            title: "Math Classroom",
            subtitle: "Ask Ava broader math questions and learn at your grade level.",
            path: "/education/math",
            icon: "∑",
            glow: "rgba(0, 224, 255, 0.35)",
            featured: true,
        },
        {
            title: "History",
            subtitle: "Explore people, events, timelines, government, and civics.",
            path: "/education/history",
            icon: "H",
            glow: "rgba(255, 190, 100, 0.30)",
            featured: true,
        },
        {
            title: "Reading",
            subtitle: "Practice comprehension, vocabulary, passages, and literary analysis.",
            path: "/education/reading",
            icon: "R",
            glow: "rgba(150, 120, 255, 0.32)",
            featured: true,
        },
        {
            title: "Science",
            subtitle: "Learn biology, chemistry, physics, Earth, and space science.",
            path: "/education/science",
            icon: "S",
            glow: "rgba(80, 255, 170, 0.30)",
            featured: true,
        },
        {
            title: "Math Board",
            subtitle: "Type a problem and let Ava solve it step by step.",
            path: "/education/mathboard",
            icon: "🧮",
            glow: "rgba(0, 255, 170, 0.28)",
            featured: true,
        },
        {
            title: "Ava Tutor",
            subtitle: "Ask Ava questions, get help, examples, and encouragement.",
            path: "/education/tutor",
            icon: "✦",
            glow: "rgba(90, 220, 255, 0.35)",
            featured: true,
        },
    ];
    const primaryItems = [
        {
            title: "Addition",
            subtitle: "Practice adding numbers with Ava step by step.",
            path: "/education/addition",
            icon: "+",
            glow: "rgba(0, 224, 255, 0.35)",
        },
        {
            title: "Subtraction",
            subtitle: "Learn how to subtract with hints and examples.",
            path: "/education/subtraction",
            icon: "−",
            glow: "rgba(120, 92, 255, 0.34)",
        },
        {
            title: "Multiplication",
            subtitle: "Build multiplication skills with guided practice.",
            path: "/education/multiplication",
            icon: "×",
            glow: "rgba(0, 255, 204, 0.30)",
        },
        {
            title: "Division",
            subtitle: "Break division down into easier steps and groups.",
            path: "/education/division",
            icon: "÷",
            glow: "rgba(255, 170, 0, 0.26)",
        },
        {
            title: "Fractions",
            subtitle: "Equivalent fractions and fraction math.",
            path: "/education/fractions",
            icon: "½",
            glow: "rgba(0, 255, 170, 0.28)",
        },
        {
            title: "Functions",
            subtitle: "Rules, inputs, outputs, and expressions.",
            path: "/education/functions",
            icon: "ƒ",
            glow: "rgba(255, 120, 220, 0.26)",
        },
        {
            title: "Decimals",
            subtitle: "Learn decimal math, comparisons, rounding, and place value.",
            path: "/education/decimals",
            icon: "0.1",
            glow: "rgba(0, 255, 255, 0.28)",
        },
        {
            title: "Essay Writing",
            subtitle: "Grammar help, introductions, conclusions, and essay guidance.",
            path: "/education/essay-writing",
            icon: "✍",
            glow: "rgba(255, 180, 80, 0.26)",
        },
    ];
    const supportItems = [
        {
            title: "Flash Cards",
            subtitle: "Quick practice cards for core math skills.",
            path: "/education/flashcards",
            icon: "▣",
            glow: "rgba(255, 80, 170, 0.28)",
        },
        {
            title: "Grade Levels",
            subtitle: "Choose the right learning level.",
            path: "/education/grades",
            icon: "A",
            glow: "rgba(90, 255, 140, 0.26)",
        },
        {
            title: "Back to Games",
            subtitle: "Return to the Games Hub.",
            path: "/games",
            icon: "←",
            glow: "rgba(255, 210, 110, 0.26)",
        },
    ];
    function applyHover(e, glow, featured) {
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = `0 8px 18px rgba(0,0,0,0.24), 0 0 12px ${glow}`;
        e.currentTarget.style.borderColor = "rgba(110, 235, 255, 0.34)";
        if (featured) {
            e.currentTarget.style.background =
                "linear-gradient(180deg, rgba(10,20,34,0.98) 0%, rgba(6,14,24,1) 100%)";
        }
    }
    function clearHover(e, featured) {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.02)";
        e.currentTarget.style.borderColor = featured
            ? "rgba(90, 240, 255, 0.24)"
            : "rgba(90, 220, 255, 0.18)";
        e.currentTarget.style.background = featured
            ? "linear-gradient(180deg, rgba(8,18,30,0.98) 0%, rgba(5,10,18,1) 100%)"
            : "linear-gradient(180deg, rgba(10,16,28,0.96) 0%, rgba(5,10,18,0.98) 100%)";
    }
    function renderCard(item) {
        return (_jsx("button", { type: "button", onClick: () => navigate(item.path), style: {
                ...cardBase,
                minHeight: item.featured ? "94px" : "90px",
                border: item.featured
                    ? "1px solid rgba(90, 240, 255, 0.24)"
                    : cardBase.border,
                background: item.featured
                    ? "linear-gradient(180deg, rgba(8,18,30,0.98) 0%, rgba(5,10,18,1) 100%)"
                    : cardBase.background,
            }, onMouseEnter: (e) => applyHover(e, item.glow, item.featured), onMouseLeave: (e) => clearHover(e, item.featured), children: _jsxs("div", { style: {
                    display: "grid",
                    gridTemplateColumns: "40px minmax(0, 1fr)",
                    gap: "10px",
                    alignItems: "start",
                }, children: [_jsx("div", { style: {
                            width: item.featured ? "40px" : "38px",
                            height: item.featured ? "40px" : "38px",
                            borderRadius: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: item.icon === "🧮"
                                ? "18px"
                                : item.icon === "½" || item.icon === "ƒ"
                                    ? "20px"
                                    : "20px",
                            fontWeight: 900,
                            color: "#ffffff",
                            background: "linear-gradient(180deg, rgba(30,220,255,0.22) 0%, rgba(255,255,255,0.08) 100%)",
                            boxShadow: `0 0 10px ${item.glow}`,
                            flexShrink: 0,
                        }, children: item.icon }), _jsxs("div", { style: { minWidth: 0 }, children: [_jsxs("div", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    marginBottom: "4px",
                                    flexWrap: "wrap",
                                }, children: [_jsx("div", { style: {
                                            fontSize: item.featured ? "15px" : "14px",
                                            fontWeight: 800,
                                            letterSpacing: "0.01em",
                                            lineHeight: 1.08,
                                        }, children: item.title }), item.featured && (_jsx("span", { style: {
                                            fontSize: "8px",
                                            fontWeight: 900,
                                            letterSpacing: "0.12em",
                                            textTransform: "uppercase",
                                            padding: "3px 6px",
                                            borderRadius: "18px",
                                            color: "#09141d",
                                            background: "linear-gradient(180deg, #ffffff 0%, #8ffcff 100%)",
                                        }, children: "Featured" }))] }), _jsx("div", { style: {
                                    fontSize: item.featured ? "11px" : "10.5px",
                                    lineHeight: 1.24,
                                    color: "rgba(236,250,255,0.74)",
                                }, children: item.subtitle })] })] }) }, item.title));
    }
    return (_jsxs("div", { style: pageStyle, children: [_jsxs("div", { style: shellStyle, children: [_jsxs("div", { style: { ...panelStyle, marginBottom: "8px" }, children: [_jsx("div", { style: {
                                    fontSize: "10px",
                                    letterSpacing: "0.18em",
                                    textTransform: "uppercase",
                                    color: "#79f3ff",
                                    fontWeight: 800,
                                    marginBottom: "2px",
                                }, children: "AVAAIO Education Center" }), _jsx("h1", { style: {
                                    margin: 0,
                                    fontSize: "clamp(20px, 2.8vw, 34px)",
                                    lineHeight: 1,
                                    fontWeight: 900,
                                    color: "#19e6ff",
                                    background: "linear-gradient(90deg,#8ffcff,#ffffff)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    textShadow: "0 0 24px rgba(0,255,255,0.22)",
                                    wordBreak: "break-word",
                                }, children: "Learn With Ava" }), _jsx("p", { style: {
                                    margin: "4px 0 0",
                                    fontSize: "clamp(10px, 1vw, 13px)",
                                    color: "rgba(236,250,255,0.82)",
                                    maxWidth: "1100px",
                                    lineHeight: 1.25,
                                }, children: "Build skills with Ava through step-by-step math help, guided tutoring, flash-card practice, grade-level learning, and interactive tools designed to make studying feel easier, faster, and more personal." })] }), _jsxs("div", { style: {
                            ...panelStyle,
                            marginBottom: "16px",
                            padding: "16px 18px",
                        }, children: [_jsx("div", { style: {
                                    fontSize: "14px",
                                    fontWeight: 800,
                                    color: "#ecfaff",
                                    marginBottom: "1px",
                                }, children: "Featured Learning Tools" }), _jsx("div", { style: {
                                    fontSize: "11px",
                                    color: "rgba(236,250,255,0.70)",
                                    lineHeight: 1.2,
                                }, children: "Jump into Ava\u2019s strongest learning experiences for solving, tutoring, and guided practice." })] }), _jsx("div", { className: "education-grid education-grid-featured", style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "14px",
                            alignItems: "stretch",
                            marginBottom: "16px",
                        }, children: featuredItems.map(renderCard) }), _jsx("div", { style: {
                            ...panelStyle,
                            marginBottom: "16px",
                            padding: "16px 18px",
                        }, children: _jsxs("div", { style: {
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }, children: [_jsxs("div", { children: [_jsx("div", { style: {
                                                fontSize: "14px",
                                                fontWeight: 800,
                                                color: "#ecfaff",
                                                marginBottom: "1px",
                                            }, children: "Core Math Subjects" }), _jsx("div", { style: {
                                                fontSize: "12px",
                                                color: "rgba(236,250,255,0.78)",
                                                lineHeight: 1.45,
                                            }, children: "Choose a subject and start practicing with guided explanations, examples, and support." })] }), _jsx("div", { style: {
                                        fontSize: "10px",
                                        color: "#8ef6ff",
                                        border: "1px solid rgba(0,255,255,0.12)",
                                        borderRadius: "18px",
                                        padding: "5px 8px",
                                        background: "rgba(0, 0, 0, 0.18)",
                                        lineHeight: 1.1,
                                    }, children: "Math & Writing Paths: addition \u2022 subtraction \u2022 multiplication \u2022 division \u2022 fractions \u2022 functions \u2022 decimals \u2022 essay writing" })] }) }), _jsx("div", { className: "education-grid education-grid-primary", style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                            gap: "14px",
                            alignItems: "stretch",
                            marginBottom: "16px",
                        }, children: primaryItems.map(renderCard) }), _jsxs("div", { style: {
                            ...panelStyle,
                            marginBottom: "16px",
                            padding: "16px 18px",
                        }, children: [_jsx("div", { style: {
                                    fontSize: "14px",
                                    fontWeight: 800,
                                    color: "#ecfaff",
                                    marginBottom: "1px",
                                }, children: "More Ways to Learn" }), _jsx("div", { style: {
                                    fontSize: "11px",
                                    color: "rgba(236,250,255,0.70)",
                                    lineHeight: 1.2,
                                }, children: "Extra practice tools, grade-level support, and quick navigation for learning sessions." })] }), _jsx("div", { className: "education-grid education-grid-secondary", style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                            gap: "14px",
                            alignItems: "stretch",
                        }, children: supportItems.map(renderCard) }), _jsx("style", { children: `
          @media (max-width: 1200px) {
            .education-grid-featured,
            .education-grid-primary,
            .education-grid-secondary {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }
          }

          @media (max-width: 760px) {
            .education-grid-featured,
            .education-grid-primary,
            .education-grid-secondary {
              grid-template-columns: 1fr !important;
            }
          }
        ` })] }), _jsx("style", { children: `
            @media (max-width: 768px) {
              button {
                min-height: 48px !important;
              }
            }

            @supports (padding: max(0px)) {
              body {
                padding-bottom: env(safe-area-inset-bottom);
              }
            }
          ` })] }));
}
